import { render, staticRenderFns } from "./AdConfig.vue?vue&type=template&id=17dec012"
import script from "./AdConfig.vue?vue&type=script&lang=js"
export * from "./AdConfig.vue?vue&type=script&lang=js"
import style0 from "./AdConfig.vue?vue&type=style&index=0&id=17dec012&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports